import React from "react";

const ICarret = ({
  color = "#252526",
  width = "14",
  height = "14",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      {...props}
    >
      <path
        d="M9.93453 7.30977L5.55953 11.6848C5.51888 11.7254 5.47063 11.7577 5.41752 11.7797C5.36441 11.8017 5.30748 11.813 5.25 11.813C5.19251 11.813 5.13559 11.8017 5.08248 11.7797C5.02937 11.7577 4.98112 11.7254 4.94047 11.6848C4.89982 11.6441 4.86758 11.5959 4.84558 11.5428C4.82358 11.4897 4.81226 11.4327 4.81226 11.3752C4.81226 11.3178 4.82358 11.2608 4.84558 11.2077C4.86758 11.1546 4.89982 11.1064 4.94047 11.0657L9.00648 7.00024L4.94047 2.93477C4.85837 2.85268 4.81226 2.74134 4.81226 2.62524C4.81226 2.50915 4.85837 2.3978 4.94047 2.31571C5.02256 2.23362 5.1339 2.1875 5.25 2.1875C5.3661 2.1875 5.47744 2.23362 5.55953 2.31571L9.93453 6.69071C9.97521 6.73134 10.0075 6.7796 10.0295 6.83271C10.0515 6.88582 10.0628 6.94275 10.0628 7.00024C10.0628 7.05774 10.0515 7.11467 10.0295 7.16778C10.0075 7.22089 9.97521 7.26914 9.93453 7.30977Z"
        fill={color}
      />
    </svg>
  );
};

export default ICarret;
